// extracted by mini-css-extract-plugin
export var compactFilters = "_cr-4";
export var detailImage = "_cr-1";
export var dropdownContainer = "_cr-2";
export var imageContainer = "_cr-0";
export var selectedCard = "_cr-3";